/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Hop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Hop"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#F90"
        fillRule="evenodd"
        d="M13.132 3.656c-.269.194-.483.62-.483 2.08h-1.298c0-1.417.163-2.53 1.028-3.154.41-.297.912-.431 1.452-.5.541-.07 1.193-.082 1.947-.082.358 0 .649.295.649.66 0 .363-.29.659-.65.659-.757 0-1.333.013-1.783.07-.452.059-.706.154-.862.267"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M13.132 3.656c-.269.194-.483.62-.483 2.08h-1.298c0-1.417.163-2.53 1.028-3.154.41-.297.912-.431 1.452-.5.541-.07 1.193-.082 1.947-.082.358 0 .649.295.649.66 0 .363-.29.659-.65.659-.757 0-1.333.013-1.783.07-.452.059-.706.154-.862.267"
        clipRule="evenodd"
      />
      <path
        fill="#94B200"
        d="M10.584 18.101c.347.282.67.494.915.65l.5.318.52-.33c.237-.15.557-.354.905-.627a5.8 5.8 0 0 0 1.165 1.128c-.541 1.59-1.853 2.34-2.59 2.76-.73-.418-2.027-1.224-2.576-2.768a6 6 0 0 0 1.161-1.13m-2.01-2.791c.315.9.802 1.6 1.31 2.142-.733.975-1.625 1.407-2.17 1.67-.394-.43-1.034-1.183-1.28-2.36a6.6 6.6 0 0 0 2.14-1.452m6.863.012c.39.389.788.698 1.18.945.33.208.651.369.95.494-.247 1.177-.887 1.93-1.282 2.36-.54-.261-1.424-.688-2.155-1.65q.194-.2.378-.434c.373-.473.7-1.04.929-1.715m-5.338-2.114c.531.465 1.06.819 1.5 1.028l.4.19.401-.19c.438-.208.97-.553 1.508-1.014l.032.059q.362.663.755 1.185c-.451 2.046-1.905 2.969-2.695 3.47-.787-.499-2.229-1.498-2.688-3.48a9.6 9.6 0 0 0 .787-1.248m-1.513-1.691a9 9 0 0 0 .803 1q-.073.149-.157.301c-1.463 2.698-3.36 3.184-4.308 3.427-.295-.681-.793-1.99-.207-3.85 1.037-.045 2.438-.22 3.87-.878m6.853.012c1.421.648 2.811.821 3.843.866.585 1.86.088 3.169-.207 3.85-.948-.243-2.845-.73-4.308-3.426a9 9 0 0 1-.145-.28 9 9 0 0 0 .816-1.01"
      />
      <path
        fill="#94B200"
        d="M12 3.778c1.889 0 3.777.84 3.777 3.836S13.26 12.77 12 13.37c-1.26-.6-3.778-2.877-3.778-5.755 0-2.877 1.889-3.836 3.778-3.836"
      />
      <path
        fill="#94B200"
        d="M8.631 4.03c-.859.814-1.353 2.014-1.353 3.584 0 1.144.33 2.186.807 3.081-1.74.767-3.433.76-4.392.755H3.5c0-1.279.416-4.103 2.492-5.964.894-.802 1.782-1.23 2.64-1.456m6.806.018c.835.232 1.7.658 2.57 1.438 2.076 1.861 2.492 4.685 2.492 5.963h-.193c-.955.005-2.638.013-4.37-.743.466-.89.785-1.93.785-3.092 0-1.568-.46-2.757-1.284-3.566"
      />
    </g>
  </svg>
);

export const HopIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'hop-icon'}
      icon={Hop}
      {...props}
      size={size}
    />
  );
};
